import { ArrowDownLeft, ArrowUpRight, Banknote, HandCoins, Hourglass, Wallet } from "lucide-react";
import { fmtDisplay } from "../lib/currency";

export default function DashboardStats({ totals, count, month, currency = "TRY", rates = {} }) {
  const f = value => fmtDisplay(value, currency, rates);
  const net = totals.income - totals.expense;
  const collectRatio = totals.income ? Math.round((totals.collected / totals.income) * 100) : 0;

  return (
    <section className="stats">
      <div className="stat-card income">
        <div className="stat-icon"><ArrowUpRight/></div>
        <span>Toplam gelir <em className="hint">(komisyon)</em></span>
        <strong data-testid="total-income">{f(totals.income)}</strong>
        <small>Ciro <span data-testid="total-gross">{f(totals.gross)}</span></small>
      </div>
      <div className="stat-card collected">
        <div className="stat-icon"><HandCoins/></div>
        <span>Tahsil edilen</span>
        <strong data-testid="total-collected">{f(totals.collected)}</strong>
        <small>Gelirin <b data-testid="collect-ratio">%{collectRatio}</b>'i tahsil edildi</small>
      </div>
      <div className="stat-card outstanding">
        <div className="stat-icon"><Hourglass/></div>
        <span>Tahsil edilmeyen</span>
        <strong data-testid="total-outstanding">{f(Math.max(totals.income - totals.collected, 0))}</strong>
        <small>{totals.income - totals.collected < 0 ? "Gelirden fazla tahsilat var" : "Bu dönemden kalan alacak"}</small>
      </div>
      <div className="stat-card expense">
        <div className="stat-icon"><ArrowDownLeft/></div>
        <span>Toplam gider</span>
        <strong data-testid="total-expense">{f(totals.expense)}</strong>
        <small>Ödenen <span data-testid="expense-paid">{f(totals.expense_paid)}</span> · Bekleyen <span data-testid="expense-unpaid">{f(totals.expense - totals.expense_paid)}</span></small>
      </div>
      <div className={`stat-card cash ${totals.collected - totals.expense_paid < 0 ? "negative" : ""}`}>
        <div className="stat-icon"><Wallet/></div>
        <span>Nakit akış <em className="hint">(gerçekleşen)</em></span>
        <strong data-testid="cash-flow-realized">{f(totals.collected - totals.expense_paid)}</strong>
        <small>Tahsilat − ödenen gider</small>
      </div>
      <div className={`stat-card cash-accrual ${totals.collected - totals.expense < 0 ? "negative" : ""}`}>
        <div className="stat-icon"><Banknote/></div>
        <span>Nakit akış <em className="hint">(tüm giderlerle)</em></span>
        <strong data-testid="cash-flow-accrual">{f(totals.collected - totals.expense)}</strong>
        <small>Tahsilat − tüm giderler</small>
      </div>
      <div className={`stat-card result ${net < 0 ? "negative" : ""}`}>
        <div className="stat-icon">₺</div>
        <span>Net sonuç <em className="hint">(tahakkuk)</em></span>
        <strong data-testid="net-result">{f(net)}</strong>
        <small>Gelir − gider</small>
      </div>
      <div className="stat-card neutral">
        <div className="stat-icon">#</div>
        <span>Kayıt sayısı</span>
        <strong data-testid="transaction-count">{count}</strong>
        <small>{month} dönemi</small>
      </div>
    </section>
  );
}
